import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import CustomInput from "../../assets/components/customInput";
import CustomSelect from "../../assets/components/CustomSelect";
import classes from "./styles/style.module.css";
import Loading from "../../assets/containers/loadingDialog";
import CustomButton from "../../assets/components/CustomButton";
import UsersRequests from "../../assets/services/user";
import CustomDatePicker from "../../assets/components/DatePicker";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

const UpdateUserFields = () => {
  const dateFormat = {
    date: new Date(),
    gregorian: new DateObject({
      date: new Date(),
      format: "YYYY/MM/DD",
    })
      .convert(gregorian, gregorian_en)
      .format(),
  };

  const [personalCode, setpersonalCode] = useState("");
  const [enrollNationalCode, setenrollNationalCode] = useState("");
  const [relation, setRelation] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [wohPhone, setWohPhone] = useState("");
  const [birthDay, setBirthDay] = useState(dateFormat);
  const [cooperation, setCooperation] = useState("");
  const [gender, setGender] = useState("");

  const getAssociationType = (type) => {
    if (type === "personnel") {
      return "پرسنل";
    } else if (type === "retired") {
      return "بازنشسته";
    } else if (type === "contractor") {
      return "پیمانکار";
    } else if (type === "saba") {
      return "فولاد صبا";
    }
  };

  // const [oldpassword, setOldpassword] = useState("");
  // const [newpassword, setNewpassword] = useState("");

  const dispatch = useDispatch();

  const { currentUser, loading_update_user_pass } = useSelector(
    ({ user }) => user
  );

  useEffect(() => {
    if (currentUser) {
      setRelation(currentUser.relation);
      setName(currentUser.fullName);
      setPhoneNumber(currentUser.phone);
      setGender(currentUser.gender === "female" ? "زن" : "مرد");
      setCooperation(getAssociationType(currentUser.associationType));
      setWohPhone(currentUser.wohPhone ? currentUser.wohPhone : "");
      setBirthDay({
        date: currentUser.birthDate,
        gregorian: new DateObject({
          date: currentUser.birthDate,
          format: "YYYY/MM/DD",
        })
          .convert(gregorian, gregorian_en)
          .format(),
      });
    }
  }, [currentUser]);

  const convertFromDate = (date, format = birthDay.format) => {
    let object = { date, format };
    setBirthDay({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  const handleUpdateUser = () => {
    const data = {
      relation: relation,
      fullName: name,
      phone: phoneNumber,
      gender: gender === "مرد" ? "male" : "female",
      associationType:
        cooperation === "پرسنل"
          ? "personnel"
          : cooperation === "بازنشسته"
          ? "retired"
          : cooperation === "فولاد صبا"
          ? "saba"
          : "contractor",
      birthDate: birthDay.gregorian.replace(/\//g, "-"),
      wohPhone: wohPhone,
    };
    dispatch(UsersRequests.updateUserInfo(currentUser._id, data));
  };

  //   const handleUpdateUser = () => {
  //     if (userProfileImage) {
  //       dispatch(
  //         UsersRequests.updateUser(currentUser._id, {
  //           profileImage: userProfileImage,
  //         })
  //       );
  //     }
  //   };

  return (
    <div className={classes.infoUserContainer}>
      <CustomInput
        placeholder={"کد ملی"}
        label={"کد ملی"}
        value={currentUser.nationalCode}
        handleChange={(value) => setenrollNationalCode(value)}
        name={"nationalCode"}
        disabled
      />
      <CustomInput
        placeholder={"کد پرسنلی"}
        label={"کد پرسنلی"}
        value={currentUser.personnelCode}
        handleChange={(value) => setpersonalCode(value)}
        name={"personalCode"}
        disabled
      />
      <CustomSelect
        label={"نسبت"}
        handleChange={(value) => setRelation(value)}
        value={relation}
        options={["کارمند فولاد", "همسر", "فرزند دختر", "فرزند پسر"]}
        name={"relation"}
        disabled
      />
      <CustomInput
        placeholder={"نام و نام‌خانوادگی"}
        label={"نام و نام‌خانوادگی"}
        value={name}
        handleChange={(value) => setName(value)}
        name={"name&familyName"}
        disabled
      />

      <CustomInput
        placeholder={"شماره تلفن"}
        label={"شماره تلفن"}
        value={phoneNumber}
        handleChange={(value) => setPhoneNumber(value)}
        name={"telephone"}
        disabled
      />
      <CustomInput
        placeholder={"شماره تماس همسر"}
        label={"شماره تماس همسر"}
        value={wohPhone}
        handleChange={(value) => setWohPhone(value)}
        name={"wohPhone"}
        disabled
      />
      <CustomDatePicker
        handleChange={convertFromDate}
        val={birthDay}
        lable={"تاریخ تولد"}
        disabled
      />
      <CustomSelect
        label={"نوع همکاری"}
        handleChange={(value) => setCooperation(value)}
        value={cooperation}
        options={["پرسنل", "بازنشسته", "پیمانکار"]}
        name={"cooperation"}
        placeHolder={"نوع همکاری"}
        disabled
      />
      <CustomSelect
        label={"جنسیت"}
        handleChange={(value) => setGender(value)}
        value={gender}
        options={["زن", "مرد"]}
        name={"gender"}
        placeHolder={"جنسیت"}
        disabled
      />
      {/* <CustomInput
        label={"رمز قبلی"}
        placeholder={""}
        passInput={true}
        value={oldpassword}
        handleChange={(value) => setOldpassword(value)}
        name={"oldPass"}
      />
      <CustomInput
        label={"رمز عبور فعلی"}
        placeholder={""}
        passInput={true}
        value={newpassword}
        handleChange={(value) => setNewpassword(value)}
        name={"newpass"}
      /> */}
      {loading_update_user_pass ? (
        <div className="w-100 d-flex  my-3 justify-content-center ">
          <Loading size={20} />
        </div>
      ) : (
        <CustomButton
          clickHandler={handleUpdateUser}
          text={"ویرایش"}
          styles={{ marginBlock: "30px" }}
        />
      )}
    </div>
  );
};

export default UpdateUserFields;
